import React from "react";
import {
  Container,
  Row,
  Col,
  Form,
  Button,
  ButtonGroup,
} from "react-bootstrap";
import { styles } from "./style";
import { css } from "aphrodite";
import Paginator from "../Paginator";
import "./TableFilterBar.css";
export default function TableFilterBar({
  title,
  filterStatus,
  setFilterStatus,
  taskCounts,
  newTask,
  todoTask,
  completetdTask,
  pages,
  actionPerPage,
  changePage,
  perPage,
  currentPage,
  pagination
}) {
  return (
    <Container fluid className="table-filter-bar px-0">
      <Row
        className="filter-bar-row"
        style={{ backgroundColor: "#626365" }}
      >
        <Col lg={5} style={{ padding: 0 }} className="filter-bar-tabs">
          {title !== "tasks" && title !== "clients" && title !== "drilldown" ? (
            <Form.Label
              style={{
                padding: "13px 0px 0px 13px",
                fontSize: "17px",
                color: "#fff",
                textTransform: "uppercase",
              }}
            >
              {title}
            </Form.Label>
          ) : (
            <>{title !== "drilldown" && <ButtonGroup style={{ height: "100%" }}>
              <Button
                className={css([
                  styles.tabsStyle,
                  filterStatus === 2? styles.activatedStyle : "",
                ])}
                variant="outline-primary"
                onClick={() => setFilterStatus(2)}
              >
                {`RECENT EVENTS (${taskCounts?.info?taskCounts?.info:0})`}
              </Button>
              {/* <Button
                className={css([
                  styles.tabsStyle,
                  filterStatus === 1? styles.pendingStyle : "",
                ])}
                variant="outline-primary"
                onClick={() => setFilterStatus(1)}
              >
                {`TODO ${title} (${taskCounts?.todo?taskCounts?.todo:0})`}
              </Button> */}
              {/* <Button
                className={css([
                  styles.tabsStyle,
                  filterStatus === 1 ? styles.pendingStyle : "",
                ])}
                variant="outline-primary"
                onClick={() => setFilterStatus(1)}
              >
                {`Completed ${title} (${completetdTask.length})`}
              </Button> */}
            </ButtonGroup>}
          </>)}
        </Col>
        <Col lg={7} className="filter-bar-paginator-col">
            <Paginator
              pages={pagination?.pages || 0}
              actionPerPage={actionPerPage}
              changePage={changePage}
              perPage={perPage}
              currentPage={pagination?.currentPage || 1}
            />
          </Col>
      </Row>
    </Container>
  );
}
